@if (!control && invalidKey) {
  <p class="error-message"><small translate>{{ invalidKey }}</small></p>
}

@if (control && control.invalid && (control.dirty || control.touched)) {
  @if (invalidKey) {
    <p class="error-message"><small translate>{{ invalidKey }}</small></p>
  } @else {
    @for (error of control.errors | keyvalue; track error) {
      <p class="error-message"><small>{{
        'common.form.errors.' + (error.key) | translate: {
        min: error.value.min,
      max: error.value.max } }}</small></p>
    }
  }
}


